<template>
    <main-layout>
        <div class="container azSize">
            <H1 class="pageTitle isPoppins">Slink Details</H1>
          
            <div id="slinkCard" class="wideLimitWidth top20 accSettingsForm">
                <div @click="hideDetail" class="is-pulled-right has-text-weight-bold has-text-white" id="backToList">
                    <i class="fa fa-arrow-alt-circle-left "></i> Back To List
                </div><br>
                <button v-if="!payLoad.isTrial" class="button is-small  is-pulled-right top20 is-warning" @click="cancelReinstateSubscr(payLoad.status)">{{slinkActionLabel}}</button>
                <button v-if="payLoad.isTrial" class="button   is-pulled-right top20 is-warning" @click="purchase"><b>Purchase Slink</b></button>
                <div class="slinkCard" >
                    <div class="topPart" id="slinkHeader">
                        <header class="has-text-white">
                            <div class="is-size-1  bottom10 has-text-yell top-20"><img src="@/assets/img/chevronsW.png" width="30" /><span>{{payLoad.slink.toLowerCase()}} <span class="is-size-4 has-text-grey">{{payLoad.isTrial ? '(Trial)' : ''}}</span></span></div>

                            <button class="button is-small top10 is-warning right10 " @click="showAnalytics(payLoad.slink.toLowerCase(), $event, payLoad.code)"><i class="fas fa-chart-bar is-size-5"></i></button>
                           <!--  <div class="is-size-5 top-18 left20 has-text-grey">slink.com/{{payLoad.slink.toLowerCase()}}</div> -->
                            <div class="has-text-right">
                                <span class="is-italic has-text-weight-normal has-text-danger left30" v-show="payLoad.status == constants.status.SlinkInGracePeriod.longCode">Disabled due to Subscription Payment Failure</span>
                                <div class="is-size-7 left30">Plan: {{payLoad.code | planFilter}}</div> 
                                <div class="is-size-7 left30" v-show="payLoad.status != constants.status.SlinkInGracePeriod.longCode">Status: {{payLoad.status | statusString}}</div> 
                                <div v-if="!payLoad.isTrial" class="is-size-7 left30">{{payLoad.status | actionString}} {{az.dateCalc(payLoad.createDate, payLoad.code)}}</div> 
                                <div v-if="payLoad.isTrial" class="is-size-7 left30">Expires: {{az.dateConvertAdd30(payLoad.createDate)}}</div> 
                            </div>
                        </header>


                        <div>
                           <!--  <span class="has-text-weight-bold has-text-dark isPoppins left5 is-size-5">Redirects to:</span> --> <!-- <button class="button is-pulled-right is-small slinkEditBt" @click="editSlink">EDIT</button> -->
                          
                            <div class="slinkUrlContainer  posRel top5" @click="editSlink">
                                <div class="">
                                   
                                    <div class="left20  is-size-4  isPoppins"><img src="@/assets/img/chevronsW.png" width="18" class="right3" /><b class="has-text-yell">{{payLoad.slink.toLowerCase()}}</b></div>
                                    <div class="is-size-8 has-text-light left20"><b>slink.com/{{payLoad.slink.toLowerCase()}}</b></div>
                                    
                                </div>
                                <div class="columns">
                                    <div class="column is-two-thirds">
                                   <div class="left35 subDescBlock">
                                            <div class="is-inline-block subCardIcon"><i :class="'fa fa-' + chooseIcon(payLoad.url)"></i></div>
                                            <div class="slinkContainerDisplayUrl top8 is-size-6  has-text-white is-inline-block">{{uFilter(payLoad.url) || 'unassigned'}}</div>
                                            <div class="is-size-5 top-5">{{payLoad.description || '--'}}</div>
                                        
                                          <!--   <div class="is-size-5 top-5">{{item.description || '---'}}</div> -->
                                    </div>
                                    </div>
                                    <div class="column is-one-third has-text-left mngSlinkPageOnCol mobileNoBorders">
                                        <div class="top10 slinksPageDiv mobileNoBorders left10">SlinkPage: <span class="isPoppins"><b>{{payLoad.linksPage ? 'on' : 'off'}}</b></span></div>
                                        <div class=""><div class="qrIconDiv top10 left10 is-inline-block" @click="doQR(payLoad.slink.toLowerCase() , payLoad.url, $event )"> <i  class="fa fa-qrcode has-text-white"></i> <span class="is-size-6">Create QR</span></div></div>
                                    </div>
                                </div>
        
                            </div>
                        </div>
                        <div v-show="!payLoad.url && !isLoading" class="has-text-light top10 is-size-5"><i class="fa fa-arrow-up has-text-yell"></i> <i>Your slink is not pointing anywhere yet. Click on it and tell us where you would like to point it to enable redirection.</i></div>
                    </div>  

                </div>

                <div class="isPoppins is-size-3 has-text-turk is-inline-block" >subslinks  <i class="fa fa-plus-square  handCursor addSub" @click="newSub"></i></div>
                <div v-show="subslinks.length < 1 && !isLoading" class="has-text-light top10 is-size-5"><i class="fa fa-arrow-up has-text-yell"></i> <i>Click the plus sign to add your first subslink</i></div>
               
                <div class="is-inline-block has-text-white is-pulled-right top10"><b>{{subslinks.length}} of {{Object.keys($root.newPlans).length ? limit : '-'}} used</b></div>

                <div id="subs" class="top10">
                   <div class="slinkContainerComp">
                        <div v-for="(item, i) in subslinks" :key="i" class="slinkContainer"  @click="editSub(item.name.toLowerCase(), item.url.toLowerCase(), item.subslinkId, item.showInLinksPage, item.description, item.subslinkId)">
                            <div class="">
                                <div class="left20   is-size-4  isPoppins"><img src="@/assets/img/chevronsW.png" width="18" class="right3" /><b><span class="has-text-yell">{{item.slinkName}}:</span>{{item.name}}</b></div>
                                <div class="is-size-8 has-text-light left20"><b>slink.com/{{payLoad.slink.toLowerCase() + ':' +  item.name }}</b></div>
                            </div>
                            <div class="columns bottom5">
                                <div class="column is-two-thirds">
                                   <div class="left35 subDescBlock">
                                        <div class="is-inline-block subCardIcon"><i :class="'fa fa-' + chooseIcon(item.url)"></i></div>
                                        <div class="slinkContainerDisplayUrl top8 is-size-6  has-text-white is-inline-block">{{uFilter(item.url)}}</div>
                                       
                                        <div class="is-size-5 top-5">{{item.description || '--'}}</div>
                                   </div>
                                </div>
                                <div class="column mobileNoBorders borderLeftWhite" >
                                    <div class="is-size-6 top5 has-text-white left10">show in SlinkPage: <span class="isPoppins"><b>{{item.showInLinksPage ? 'on' : 'off'}}</b></span></div>
                                    <div class="qrIconDiv is-inline-block  top10 left10" @click="doQR(payLoad.slink.toLowerCase() + ':' + item.name, item.url, $event )"> <i  class="fa fa-qrcode has-text-white"></i> <span class="is-size-6">Create QR</span></div>
                                </div>
                              
                                <div class="is-pulled-right right10">
                                    <div class="top25 right10"> <!-- <i class="fa fa-grip-horizontal has-text-white is-size-3 right5"></i> --></div>
                                </div>
                            </div>
                            
                        </div>
                        <div>

                        </div>
                    </div>
                </div>
                <br><br><br><br><br>

            </div>
            <br><br>
        </div>  
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import constants from '../STATIC/constants.js'
import { AZEventBus } from '../components/AZEventBus'
import SlinkContainer from '../components/SlinkContainer'

export default {
  props:{},
  components: {
    MainLayout,
    SlinkContainer
  },
  data: function(){
      return {
          slink: '',
          payLoad: {data:[], subPacks: [], createDate: '', slink: '', url: '', linksPage: true},
          constants,
          az: az,
          subpacks: [],
          packs: [],
          inited: false,
          subslinks: [],
          isLoading: true,
          limit: 0
      }
  },
  computed:{
      slinkActionLabel: function(){
          if(this.payLoad.status == constants.status.SlinkPendingCancel.longCode){
              return 'Reinstate Slink'
          } else if(this.payLoad.status == constants.status.SlinkInGracePeriod.longCode){
              return 'Renew Subscription'
          } else {
              return 'Remove from Subscription'
          }
      }
      
  },
  mounted: function(){
    this.slink = this.$route.query.s
    if(this.slink == undefined){
        this.$router.push('/mng')
    }   else {
        az.addRemSpinner(true, 'id', 'slinkHeader');  
    }
    var self = this;

    const groupBy = key => array =>
        array.reduce((objectsByKeyValue, obj) => {
            const value = obj[key];
            if(objectsByKeyValue[value]){
                objectsByKeyValue[value].arr = objectsByKeyValue[value].arr.concat(obj)
            } else {
                objectsByKeyValue[value] = {arr: [obj], status: obj.status}
            }
            return objectsByKeyValue;
        }, {});

    self.worked = function (data) {
        self.isLoading = false
        az.addRemSpinner(false, 'id', 'slinkHeader');

        //self.packs =  data.packs.Items
        //sort packs by updateDate
        /* self.packs.sort(function(a,b){
            let n1 = new Date(a.updateDate)
            let n2 = new Date(b.updateDate)

            let d1 = Date.UTC(n1.getFullYear(), n1.getMonth(), n1.getDate())
            let d2 = Date.UTC(n2.getFullYear(), n2.getMonth(), n2.getDate())
            return d1-d2
        }) */

        self.payLoad = data.slink;
        self.payLoad.linksPage = data.slink.linksPage == undefined ? true : data.slink.linksPage

    

        if(self.payLoad.url == '_url_placeholder_') self.payLoad.url = '';
        
  
        if(self.payLoad.code.split('Monthly').length > 1 || self.payLoad.code.split('Yearly').length > 1){
            self.limit = self.$root.newPlans[self.payLoad.code].limit
        } else if(self.payLoad.code == 'Trial') {
            self.limit = 3
        } else if(self.payLoad.code == 'Free') {
            self.limit = 10000
        }
        
        /* for(let x=0; x < self.payLoad.data.length; x++){
            if(self.payLoad.data[x].url == '_url_placeholder_') self.payLoad.data[x].url = '';
            if(self.payLoad.data[x].name == '_sub_placeholder_') self.payLoad.data[x].name = '';
        } */

        //* reprocess self.payLoad.data to group by packs of 3 into  subpacks array
        //let p = self.payLoad.data

        /* let byParentSubPack = groupBy('parentSubPack')
        self.subpacks = byParentSubPack(p) 
        delete self.subpacks.bundled */

        //self.subpacks = {}
        /* self.packs.forEach((i, ind) => {
            self.subpacks[i.slink] = {};
            self.subpacks[i.slink].data = i
            self.subpacks[i.slink].arr = [];
            self.payLoad.data.forEach(e => {
                if(e.parentSubPack == i.slink){
                    self.subpacks[i.slink].arr.push(e)
                }
            })
        }) */
    
        /* for(var n=2; n < p.length; n++){
            let obj = {}
            let currParent
            if(p[n].parentSubPack != p[n-1].parentSubPack){
                currParent = p[n].parentSubPack;
                obj.subs = groupBy(currParent)
            }
        } */
      
    }
    self.noWorked = function (obj) {
    self.isLoading = false
      az.addRemSpinner(false, 'id', 'slinkHeader');
      self.$root.showModalOK({message: 'There was en arror loading contents.'})
    }

    function worked2(d){
        self.subslinks = d.subslinks
        self.subslinks.forEach(e => {
            e.dateObj = new Date(e.createDate)
        })
        self.subslinks.sort((a,b) => {
            if (a.dateObj < b.dateObj) {
                return 1;
            }
            if (a.dateObj > b.dateObj) {
                return -1;
            }

            // names must be equal
            return 0;
        })
    }

    function nw2(){
        self.$root.showModalOK({message: 'There was en arror loading contents.'})
    }

    function init(){
      if(self.slink != undefined){
        self.inited = true
        self.$root.apiClient.get('api/account/mngslink/' + encodeURIComponent(self.slink), {}, self.worked, self.noWorked)
        self.$root.apiClient.get(`api/account/mngslink/${self.slink}/subslinks`, {}, worked2, nw2)
      }
    }

      if(self.$root.doneFederating){
        init();
      }

      AZEventBus.$once('onFederate', msg => {
        if(self.inited == false)
                init();
        });
    
  },
  methods:{
    hideDetail: function(){
        this.$router.push('/mng')
    },
    editSlink: function(){

        let self = this;
        this.$root.loadedModalComponent = 'ModalEdit'
        this.$root.modalPropsObj = {slink: this.payLoad.slink.toLowerCase(), url: this.payLoad.url == '' ? '' : this.payLoad.url.toLowerCase() , editingSub: false, linksPage: this.payLoad.linksPage, slinkDesc: this.payLoad.description, pageDesc: this.payLoad.pageDescription, callBack: callApi}
        this.$root.showModal = true

        function callApi(url, a, b, c, d, linksPage, slinkDesc, pageDesc){
            az.addRemSpinner(true, 'id', 'slinkHeader');
            function worked(data){
                az.addRemSpinner(false, 'id', 'slinkHeader');
                if(data.response == 'ok'){
                    self.payLoad.url = url == '_url_placeholder_' ? '' : url;
                    self.payLoad.linksPage = linksPage;
                    self.payLoad.description = slinkDesc
                    self.payLoad.pageDescription = pageDesc
                } else {
                    throw('error')
                }

                
            }

            function noWorked(){
                az.addRemSpinner(false, 'id', 'slinkHeader');
                self.$root.showModalOK({message: 'We are sorry! There was an error saving your changes.'})
            }
           
            this.$root.apiClient.put('api/account/seturl', {slink: self.payLoad.slink, url: url, linksPage: linksPage, description: slinkDesc, pageDescription: pageDesc}, worked, noWorked)

        }
    },
    editSub: function(name, url, id, showInPage, description, subslinkId){
        
        let self = this;
        this.$root.loadedModalComponent = 'ModalEdit';
        this.$root.modalPropsObj = {slink: this.payLoad.slink, name: name == '' ? '' : name, url: url == '' ? '' : url , editingSub: true, showInPage: showInPage == undefined ? true : showInPage, linksPage: this.payLoad.linksPage,  callBack: callApi, description: description, subslinkId: subslinkId, owner: this};
        this.$root.showModal = true;

        var oldUrl = url
   
        function callApi(url, subSlink, showInLinksPage, desc){

            az.addRemSpinner(true, 'id', 'slinkHeader');

            function worked(d){
                az.addRemSpinner(false, 'id', 'slinkHeader');
                if(d.response == 'duplicate subslink'){
                    return
                }

                az.addRemSpinner(false, 'id', 'slinkHeader');
                let i;
                for( i=0; i < self.subslinks.length; i++){
                    if(self.subslinks[i].subslinkId == id){
                        break;
                    }
                }

                self.subslinks[i].description = desc
                self.subslinks[i].showInLinksPage = showInLinksPage
                self.subslinks[i].name = subSlink == '_sub_placeholder_' ? '' : subSlink;
                self.subslinks[i].url = url == '_url_placeholder_' ? '' : url;
            }

            function noWorked(){
                //az.addRemSpinner(false, 'id', 'bundledSubs');
                self.$root.showModalOK({message: 'We are sorry! There was an error saving your changes.'})
            }

            if(url == '') url = '_url_placeholder_';
            if(subSlink == '') subSlink = '_sub_placeholder_'

           

            this.$root.apiClient.put('api/account/setsuburl', {slink: self.payLoad.slink, url: url, name: subSlink, subslinkId: id, showInLinksPage: showInLinksPage, description: desc}, worked, noWorked)

        }
    },

    newSub: function(){
        if(this.subslinks.length == this.limit){
            this.$root.showModalOK({message: 'You have reached the subslink limit of your plan. If you would like more subslinks, please contact us.'})
            return
        }

        let self = this;
        this.$root.loadedModalComponent = 'ModalEdit';
        this.$root.modalPropsObj = {slink: this.payLoad.slink, name: name == '' ? '' : name, url: '' , editingSub: true, showInPage: true, linksPage: true,  callBack: callApi, description: '', nORe: 'n'};
        this.$root.showModal = true;

       // var oldUrl = url
   
        function callApi(url, subSlink, showInLinksPage, desc){

            az.addRemSpinner(true, 'id', 'slinkHeader');

            function worked(d){
                az.addRemSpinner(false, 'id', 'slinkHeader');
                if(d.response == 'duplicate subslink'){
                    return
                }

                //push new sub into subslinks

                var o = {
                    PK: "SLINK#" + self.slink,        
                    SK: "PATH#" + self.slink + ':' + subSlink,
                    accountId: self.$root.userAttrs.sub,
                    createDate: "",
                    description: desc,
                    itemId: "",
                    name: subSlink,
                    showInLinksPage: showInLinksPage,
                    slink: "subslink|" + d.subslinkId,
                    slinkName: self.slink,
                    status: "SlinkActive",
                    subslinkId: d.subslinkId,
                    type: "subslink",
                    updateDate: "",
                    url: url,
                    dateObj: new Date()
                }

                self.subslinks.push(o)
                self.subslinks.sort((a,b) => {
                    if (a.dateObj < b.dateObj) {
                        return 1;
                    }
                    if (a.dateObj > b.dateObj) {
                        return -1;
                    }

                    // names must be equal
                    return 0;
                })
            }

            function noWorked(){
                az.addRemSpinner(false, 'id', 'slinkHeader');
                self.$root.showModalOK({message: 'We are sorry! There was an error saving your changes.'})
            }

            if(url == '') url = '_url_placeholder_';
            if(subSlink == '') subSlink = '_sub_placeholder_'

            this.$root.apiClient.post(`api/account/mngslink/${self.payLoad.slink}/subslinks`, {slink: self.payLoad.slink, url: url, name: subSlink, showInLinksPage: showInLinksPage, description: desc}, worked, noWorked)

        }

    },

    removeFromSubslinks: function(id){
        var ind = this.subslinks.findIndex(e => {
            return e.subslinkId == id
        })

        if(ind != -1){
            this.subslinks.splice(ind, 1);
        }
    },
   
    removeReinstatePack: function(id, status, i, subsId){

        var self = this

        if(status == constants.status.SlinkInGracePeriod.longCode){
            this.$router.push('/subsupdate/?s=' + subsId) 
            return
        }

        var toDo = status == constants.status.SlinkActive.longCode || status == constants.status.SlinkExistsNoUrl.longCode  ? 'remove' : 'reinstate';
        this.$root.loadedModalComponent = 'ModalAddRemPack';
        this.$root.modalPropsObj = {slink: this.payLoad.slink, callBack: callApi, pack: `${i + 1}`, toDo: 'pack|' + toDo};
        this.$root.showModal = true;

        function callApi(){
            //TODO implement remAddSpinner
            function worked(){
                az.addRemSpinner(false, 'id', `pack${i}`);
                let p = self.packs.find(e => {
                    return e.slink == id;
                })
                p.status = toDo == 'remove' ? 'SlinkPendingCancel' : 'SlinkActive';
               
            }
            function noWorked(){
                az.addRemSpinner(false, 'id', `pack${i}`);
                this.$self.showModalOK({message: 'There was an error updating the status. Please try again or contact support.'})
            }

            az.addRemSpinner(true, 'id', `pack${i}`);
            this.$root.apiClient.put('api/account/mngslink/sub', {slink: self.payLoad.slink, subSlink: id, action: toDo}, worked, noWorked)
        }
    },
    
    cancelReinstateSubscr: function(status){
        
        let self = this;

        
        if(status == constants.status.SlinkInGracePeriod.longCode){
            this.$router.push('/subsupdate/?s=' + this.payLoad.subscriptionId) 
            return
        }

        var toDo;
        if(status == constants.status.SlinkActive.longCode || status == constants.status.SlinkExistsNoUrl.longCode){
            toDo = 'remove'
        } else {
            toDo = 'reinstate'
        }
        this.$root.loadedModalComponent = 'ModalAddRemPack';
        this.$root.modalPropsObj = {slink: this.payLoad.slink, callBack: callApi, toDo: 'slink|' + toDo};
        this.$root.showModal = true;

        function callApi(toDo){
             //TODO implement remAddSpinner
            
            az.addRemSpinner(true, 'id', 'slinkHeader');

            function worked(data){
                az.addRemSpinner(false, 'id', 'slinkHeader');
                console.log(data)
                if(data.response == 'ok'){
                    if(toDo == 'reinstate')
                        self.payLoad.status = constants.status.SlinkActive.longCode;
                    else
                        self.payLoad.status = constants.status.SlinkPendingCancel.longCode;
                } else {
                    throw('error')
                }
            }

            function noWorked(){
                az.addRemSpinner(false, 'id', 'slinkHeader');
                self.$root.showModalOK({message: 'We are sorry! There was an error saving your changes.'})
            }

            if(toDo == 'reinstate'){
                this.$root.apiClient.put('api/account/mngslink/' + self.payLoad.slink, {}, worked, noWorked);
            } else {
                this.$root.apiClient.delete('api/account/mngslink/' + self.payLoad.slink, {}, worked, noWorked);
            }
         
        }
    },
    packStatusAction: function(status){
        if(status == constants.status.SlinkPendingCancel.longCode ){
            return 'Add Back'
        } else if(status == constants.status.SlinkInGracePeriod.longCode){
            return 'Renew Subscription'
        } else {
            return 'Remove'
        }
    },

    purchase: function(){
        this.$root.addToCart('trialconv', this.slink, constants.SLINK_YEARLY_PLAN.plan); 
    },

    doQR: function(slink, url, ev){
        ev.stopPropagation()
        if(url == '' || url == undefined){
            this.$root.showModalOK({message: 'Please assign a redirect URL before trying to generate a QR code.'})
            return
        }
       
        this.$root.doShowModal('modalQR', {slink: slink})


    },

    chooseIcon: function(url){
        if(url.indexOf('mailto:') == 0){
            return 'envelope'
        } else if(url.indexOf('tel://') == 0){
            return 'phone'
        } else if(url == `https://${process.env.HOST}/${this.slink}:links`){
            return 'list'
        } else {
            return 'link'
        }
    },

    uFilter: function(val){
        if(val.indexOf('tel://') == 0){
                return val.split('://')[1]
            } else if(val.indexOf('mailto:') == 0){
                return val.split(':')[1]
            } else if(val == `https://${process.env.HOST}/${this.slink}:links`){
                return 'SlinkPage'
            } 

            return val
    },
    showAnalytics: function(slink, ev, code) {
        if(code == 'SmallMonthly' || code == 'SmallYearly'){
            this.$root.showModalOK({message: 'Sorry, Basic plans do not include analytics. To get access to analytics please upgrade your plan.'})
            return
        }

        ev.stopPropagation()
        this.$router.push('/metrics/' + slink)
    }


  },

  filters: {
    planFilter: function(val){

        var v = val.split('Monthly')
        var v2 = val.split('Yearly')

        if(v.length > 1){
            if(v[0] == 'Small'){
                return 'Basic Monthly'
            } else if(v[0] == 'Medium'){
                return 'Personal Monthly'
            } else if(v[0] == 'Large'){
                return 'Pro Monthly'
            }
        } else if(v2.length > 1){
            if(v2[0] == 'Small'){
                return 'Basic Yearly'
            } else if(v2[0] == 'Medium'){
                return 'Personal Yearly'
            } else if(v2[0] == 'Large'){
                return 'Pro Yearly'
            }
        } else if(val == 'Trial'){
            return 'Trial'
        } else if(val == 'Free'){
            return 'Free'
        } else {
            return val
        }
    }
  }
   
}
</script>

<style lang="sass" scoped>
    .slinkUrlContainer
        padding: 12px 0 12px 5px
        cursor: pointer
        &:hover
            background-color: #666

    .slinkUrl  
        //border-radius: 4px
        padding: 4px
        margin-bottom: 10px
        border-left: 5px solid #50abc7
        color: #555

    .subUrl   
        padding: 4px
        margin-right: 30px
        color: #555
        margin-top: 5px
        border-left: 5px solid #50abc7
  
    .subDiv
        padding-bottom: 20px
        padding-top: 10px
        color: #333
        border-left: 8px solid #ffd83d
   
  
    
    .slinkCard
        margin-bottom: 50px
        
    .card-header
        border-radius: 10px

    .slinkEditBt
        position: relative
        top: -8px

    .subEditBt
        position: relative
        top: 0px
        left: -25px
        transform: scale(.8,.8)
  
    .azlabel
        padding: 5px
        border-left: 1px solid #ffd83d

    .azlabel2
        padding: 5px

    .topPart
        //border-left: 1px solid #ffd83d  
    
    .borderBlue
        border-left: 5px solid #d10704
        color: #999
        font-style: italic

    #backToList
        cursor: pointer  
        &:hover
            color: #888 
</style>



// WEBPACK FOOTER //
// src/pages/MngDetail.vue